import React, { useState, useEffect } from "react";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import PrivacyPolicyPage from "./components/Home/PrivacyPolicy";
import PrivacyPolicyEasyCvMaker from "./components/Home/PrivacyPolicyEasyCvMaker";
import PrivacyPolicyTranslateAI from "./components/Home/PrivacyPolicyTranslateAI";
import PrivacyPolicyTransformAI from "./components/Home/PrivacyPolicyTransformAI";
import PrivacyPolicyStyleCraftAI from "./components/Home/PrivacyPolicyStyleCraftAI";
import PrivacyPolicyMarkHub from "./components/Home/PrivacyPolicyMarkHub";
import PrivacyPolicyMatchemAllFruits from "./components/Home/PrivacyPolicyMatchemAllFruits";
import PrivacyPolicyCleanBlast from "./components/Home/PrivacyPolicyCleanBlast";
import PrivacyPolicyMarkdownConverter from "./components/Home/PrivacyPolicyMarkdownConverter";
import PrivacyPolicySeomatic from "./components/Home/PrivacyPolicySeomatic";
import FacebookDataDeletion from "./components/Home/FacebookDataDeletion";
import Footer from "./components/Footer";
import {
  BrowserRouter as Router,
  Route,
  Routes
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Contact from "./components/Home/Contact";
import Seo from "./components/Seo";

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);
  const routeWithSeo = (title, description, component) => (
    <>
      <Seo title={title} description={description} />
      {component}
    </>
  );

  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route
            path="/"
            element={routeWithSeo(
              "Mehmet Ali CELEBI | Portfolio",
              "Portfolio and projects by Mehmet Ali CELEBI.",
              <Home />
            )}
          />
          <Route
            path="/contact"
            element={routeWithSeo(
              "Contact | Mehmet Ali CELEBI",
              "Contact Mehmet Ali CELEBI.",
              <Contact />
            )}
          />
          <Route
            path="/privacy-policy"
            element={routeWithSeo(
              "Privacy Policy | Mehmet Ali CELEBI",
              "Privacy policy information.",
              <PrivacyPolicyPage />
            )}
          />
          <Route
            path="/privacy-policy/careercraft-cv"
            element={routeWithSeo(
              "CareerCraft CV Privacy Policy",
              "CareerCraft CV privacy policy details.",
              <PrivacyPolicyEasyCvMaker />
            )}
          />
          <Route
            path="/privacy-policy/translate-ai"
            element={routeWithSeo(
              "Translate AI Privacy Policy",
              "Translate AI privacy policy details.",
              <PrivacyPolicyTranslateAI />
            )}
          />
          <Route
            path="/privacy-policy/transform-ai"
            element={routeWithSeo(
              "Transform AI Privacy Policy",
              "Transform AI privacy policy details.",
              <PrivacyPolicyTransformAI />
            )}
          />
          <Route
            path="/privacy-policy/stylecraft-ai"
            element={routeWithSeo(
              "StyleCraft AI Privacy Policy",
              "StyleCraft AI privacy policy details.",
              <PrivacyPolicyStyleCraftAI />
            )}
          />
          <Route
            path="/privacy-policy/markhub"
            element={routeWithSeo(
              "MarkHub Privacy Policy",
              "MarkHub privacy policy details.",
              <PrivacyPolicyMarkHub />
            )}
          />
          <Route
            path="/privacy-policy/match-em-all-fruits"
            element={routeWithSeo(
              "Match'em All: Fruits Privacy Policy",
              "Match'em All: Fruits privacy policy details.",
              <PrivacyPolicyMatchemAllFruits />
            )}
          />
          <Route
            path="/privacy-policy/cleanblast-gallery-cleaner"
            element={routeWithSeo(
              "CleanBlast: Gallery Cleaner Privacy Policy",
              "CleanBlast: Gallery Cleaner privacy policy details.",
              <PrivacyPolicyCleanBlast />
            )}
          />
          <Route
            path="/privacy-policy/markdown-converter"
            element={routeWithSeo(
              "Markdown Converter Privacy Policy",
              "Markdown Converter privacy policy details.",
              <PrivacyPolicyMarkdownConverter />
            )}
          />
          <Route
            path="/privacy-policy/seomatic"
            element={routeWithSeo(
              "Seomatic Privacy Policy",
              "Seomatic privacy policy details.",
              <PrivacyPolicySeomatic />
            )}
          />
          <Route
            path="/facebook-data-deletion"
            element={routeWithSeo(
              "Facebook Data Deletion | Mehmet Ali CELEBI",
              "Instructions for Facebook data deletion.",
              <FacebookDataDeletion />
            )}
          />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
